var map = {
	"./fbloodelf.webp": 6059,
	"./fdarkirondwarf.webp": 9396,
	"./fdracthyr.webp": 2547,
	"./fdraenei.webp": 686,
	"./fdwarf.webp": 8194,
	"./fgnome.webp": 5298,
	"./fgoblin.webp": 9065,
	"./fhuman.webp": 5767,
	"./fkultiran.webp": 314,
	"./flightforged.webp": 6139,
	"./fmagharorc.webp": 7878,
	"./fmechagnome.webp": 5094,
	"./fnightborne.webp": 2202,
	"./fnightelf.webp": 281,
	"./forc.webp": 4912,
	"./fpandaren.webp": 9087,
	"./ftauren.webp": 2969,
	"./ftroll.webp": 5661,
	"./fundead.webp": 7567,
	"./fvoidelf.webp": 3505,
	"./fvulpera.webp": 4123,
	"./fworgen.webp": 1376,
	"./mbloodelf.webp": 4466,
	"./mdarkirondwarf.webp": 4443,
	"./mdracthyr.webp": 1570,
	"./mdraenei.webp": 4873,
	"./mdwarf.webp": 7213,
	"./mgnome.webp": 2033,
	"./mgoblin.webp": 6948,
	"./mhighmountain.webp": 9104,
	"./mhuman.webp": 1864,
	"./mkultiran.webp": 1839,
	"./mlightforged.webp": 9188,
	"./mmagharorc.webp": 2537,
	"./mmechagnome.webp": 5351,
	"./mnightborne.webp": 2283,
	"./mnightelf.webp": 3668,
	"./morc.webp": 7427,
	"./mpandaren.webp": 4370,
	"./mtauren.webp": 900,
	"./mtroll.webp": 6498,
	"./mundead.webp": 8374,
	"./mvoidelf.webp": 4850,
	"./mvulpera.webp": 268,
	"./mworgen.webp": 445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;